// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3MyKo","empty":"ModalGraph_empty__KLDZV"};